import React from 'react';
import { ArrowRight, Calendar, Clock } from 'lucide-react';
interface BlogCardProps {
  title: string;
  excerpt: string;
  slug: string;
  date: string;
  readTime: string;
}
export function BlogCard({
  title,
  excerpt,
  slug,
  date,
  readTime
}: BlogCardProps) {
  return <a href={`/blog/${slug}`} onClick={e => {
    e.preventDefault();
    window.history.pushState({}, '', `/blog/${slug}`);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo(0, 0);
  }} className="group flex flex-col h-full bg-[#0a0a0a] border border-white/[0.06] rounded-xl overflow-hidden hover:border-[#c9a84c]/40 transition-all duration-300" data-id="element-73">
      <div className="p-6 flex flex-col flex-1" data-id="element-74">
        <div className="flex items-center space-x-4 text-xs text-white/40 mb-4" data-id="element-75">
          <div className="flex items-center space-x-1" data-id="element-76">
            <Calendar className="w-3 h-3" data-id="element-77" />
            <span data-id="element-78">{date}</span>
          </div>
          <div className="flex items-center space-x-1" data-id="element-79">
            <Clock className="w-3 h-3" data-id="element-80" />
            <span data-id="element-81">{readTime}</span>
          </div>
        </div>

        <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#c9a84c] transition-colors" data-id="element-82">
          {title}
        </h3>

        <p className="text-white/60 text-sm leading-relaxed mb-6 flex-1" data-id="element-83">
          {excerpt}
        </p>

        <div className="flex items-center text-[#c9a84c] text-sm font-medium mt-auto" data-id="element-84">
          <span data-id="element-85">Read Article</span>
          <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-86" />
        </div>
      </div>
    </a>;
}